import _AuthService from "./AuthService";
import _AnalyticsService from "./AnalyticsService";

export const AuthService = new _AuthService();
export const AnalyticsService = new _AnalyticsService();
